import { useAuthStore } from '../store/useAuthStore';

export interface Scope {
  /** Brand the user is scoped to, or null for global/root scope. */
  brandId: string | null;
  /** True once /auth/me has resolved. */
  meLoaded: boolean;
  /** User is scoped to a single brand (brand admin / viewer brand admin). */
  isBrandScoped: boolean;
  /** User has global scope (root). Only reliable once `meLoaded` is true. */
  isGlobalScope: boolean;
}

/**
 * Data-scope helper derived from `/auth/me`. Use this for "one brand vs all
 * brands" decisions — this is distinct from capability checks (`useCan`).
 */
export const useScope = (): Scope => {
  const brandId = useAuthStore((s) => s.brandId);
  const meLoaded = useAuthStore((s) => s.meLoaded);
  return {
    brandId,
    meLoaded,
    isBrandScoped: !!brandId,
    isGlobalScope: meLoaded && !brandId,
  };
};

export default useScope;
